<template>
	<div class="indexbg">
		<topbar></topbar>
		<header></header>
		<emallheader></emallheader>
		<div class="clear mt15"></div>
		<!--container 开始-->
		<div class="w1200 bc">
			<!--购物车：开始-->
			<div class="hq-shopping-cart">
				<!--购物流程：开始-->
				<div class="hq-reg-step">
					<ul class="ico">
						<li>
							<p class="item">shopping cart</p>
							<i class="step-count"></i>
						</li>
						<li><span class="line"></span></li>
						<li>
							<p class="item">Submit orders</p>
							<i class="step-count"></i>
						</li>
						<li><span class="line"></span></li>
						<li>
							<p class="item">confirm payment</p>
							<i class="step-count"></i>
						</li>
						<li><span class="line"></span></li>
						<li class="active">
							<p class="item">successfully ordered</p>
							<i class="step-count"></i>
						</li>
					</ul>
				</div>
				<!--购物流程：结束-->
				<!--提示：开始-->
				<div class="tipsbox success">
					<i class="icon"></i>
					<h3>Congratulations, the order is successful！</h3>
					<p class="text">Remarks: Here is the remark information, here is the remark information here is the remark information</p>
					<div class="ft">
						<a class="btn" href="javascript:void(0);" v-on:click = "jumpToOrderList()" >View all orders</a>
						<a class="btn" href="#">Back to home</a>
					</div>
				</div>
				<!--提示：结束-->
			</div>
			<!--购物车：结束-->
			<div class="clear"></div>
			<div class="mb20 ad-4 mt20"><img src="images/footer-ad-1.png" width="1200" height="60"></div>
		</div>
		<!--container 结束-->

		<div class="clear"></div>
		<footermenu></footermenu>
		<footercopyright></footercopyright>

	</div>
</template>

<script>
	import TopBar from '@/components/TopBar'
	import EmallHeader from '@/components/Header'
	import FooterMenu from '@/components/FooterMenu'
	import ShopNav from '@/components/ShopNav'
	import FooterCopyright from '@/components/FooterCopyright'
  import {ajaxUrl} from "../../../static/js/emallUtils.js"

	export default {
		name: 'orderpaysuccess',
		components: {
			'topbar': TopBar,
			'emallheader': EmallHeader,
			'footermenu': FooterMenu,
			'footercopyright': FooterCopyright,
		},
    methods:{
      jumpToOrderList:function(){
        window.location.href=ajaxUrl+"/orderManage/myOrderList.htm";
      },
    }
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/page/order/orderPaySuccess.vue